<meta name="viewport" content="width=device-width, initial-scale=1.0" />

<div class="common flex flex-row items-center {{status}}">
  {{statusProps[status]?.text}}
</div>
